<h3 class="mt-0 mb-12">{{ (type === 'IssueDate' ? 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' : 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE') | translate }}</h3>
<div class="pt-8" [formGroup]="dateFilterForm">
    <div fxLayout="column" fxLayoutAlign="space-between center">
        <div class="p-24 mb-8 w-100-p bg-lightgreybackground" fxLayout="column" fxLayoutAlign="space-between flex-start">
            <label class="mb-8">{{ afterText | translate }}</label>
            <mat-form-field class="w-100-p">
                <input
                    matInput
                    name="after"
                    formControlName="after"
                    [matDatepicker]="issuedAfterPicker"
                    placeholder="Select date"
                    readonly
                    inputmode="none"
                    (click)="issuedAfterPicker.open()"
                    (focus)="issuedAfterPicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="issuedAfterPicker"></mat-datepicker-toggle>
                <mat-datepicker #issuedAfterPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="p-24 w-100-p bg-lightgreybackground" fxLayout="column" fxLayoutAlign="space-between flex-start">
            <label class="mb-8">{{ beforeText | translate }}</label>
            <mat-form-field class="w-100-p">
                <input
                    matInput
                    name="before"
                    formControlName="before"
                    [matDatepicker]="issuedBeforePicker"
                    placeholder="Select date"
                    readonly
                    inputmode="none"
                    (click)="issuedBeforePicker.open()"
                    (focus)="issuedBeforePicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="issuedBeforePicker"></mat-datepicker-toggle>
                <mat-datepicker #issuedBeforePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</div>
